import {Component, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {HttpService, SnackbarService} from 'app/core';
import { environment as env } from '../../../environments/environment';
import { GeneralService } from 'app/core';
import { SettingsProvider } from 'app/core';
import {ProductsDataService} from 'app/domain/products/services/products.data.service';
import {Observable} from 'rxjs';
import {DialogData} from '../import-dialog/import-dialog.component';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import * as _moment from 'moment';

const moment = _moment;

export const MY_FORMATS = {
    parse: {
        dateInput: 'YYYY-MM-DD',
    },
    display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    },
};

@Component({
    selector: 'create-price-contract-dialog',
    templateUrl: 'create-price-contract-dialog.component.html',
    styleUrls: ['create-price-contract-dialog.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },

        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
})

export class CreatePriceContractDialogComponent {
    creating = false;
    productId = 0;
    priceValue = 0.01;
    selectedContract = 0;

    range = new FormGroup({
        start: new FormControl(moment()),
        end: new FormControl(moment().add(1, 'days'))
    });

    constructor(
        public snackBar: SnackbarService,
        public dialogRef: MatDialogRef<CreatePriceContractDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public generalService: GeneralService,
        public settingsService: SettingsProvider,
        public dataService: ProductsDataService,
        private http: HttpService,
        private dateAdapter: DateAdapter<Date>
    ) {
        this.dateAdapter.setLocale('en-GB');
    }

    close(): void {
        this.dialogRef.close();
    }

    onNoClick(): void {
        this.dialogRef.close({ confirm: false });
    }

    confirmFromDialog(): void {
        this.dialogRef.close({ confirm: true });
    }

    selectedContractChange(event): void {
        this.selectedContract = event.value;
    }

    priceOnBlur(event): void {
        if (event.target.value < 0) {
            event.target.value = 0.01;
        }
        this.priceValue = Number(parseFloat(event.target.value).toFixed(2));
    }

    dateToRequestData(date, isValidTo?: boolean): string {
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}T12:00:0${isValidTo ? `1` : `0`}`;
    }

    createPriceContract(): Observable<any> {
        const url = `${this.settingsService.configuration.url}${env.PriceContractDataService.apiUrlCreate}`;
        const data = {
            productId: this.dataService.productId,
            contractType: this.selectedContract,
            validFrom: this.dateToRequestData(this.range.controls.start.value.toDate()),
            validTo: this.dateToRequestData(this.range.controls.end.value.toDate(), true),
            price: this.priceValue
        };
        return this.http.post(url, data);
    }

    createPriceContractClick(): void {
        if (!this.range.controls.start.hasError('matStartDateInvalid') && !this.range.controls.end.hasError('matEndDateInvalid') && this.range.controls.start.value.toDate() &&  this.range.controls.end.value.toDate()) {
            this.creating = true;
            this.createPriceContract().subscribe(
                () => {
                    this.dialogRef.close({ confirm: true });
                    this.snackBar.info('Udało się utworzyć nowy kontrakt cenowy');
                },
                logErr => {
                    if (logErr.status === 400) {
                        this.snackBar.info('Podany okres obowiązywania nachodzi na okres obowiązywania innego kontraktu');
                    } else {
                        this.snackBar.info('Nie udało się utworzyć nowego kontraktu cenowego');
                    }
                    this.creating = false;
                },
                () => this.creating = false
            );
        }
    }
}
